import { render, staticRenderFns } from "./handhome2.vue?vue&type=template&id=86f11806&scoped=true"
import script from "./handhome2.vue?vue&type=script&lang=js"
export * from "./handhome2.vue?vue&type=script&lang=js"
import style0 from "./handhome2.vue?vue&type=style&index=0&id=86f11806&prod&lang=css"
import style1 from "./handhome2.vue?vue&type=style&index=1&id=86f11806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f11806",
  null
  
)

export default component.exports